module.exports = __webpack_public_path__ + "fd5a608a/img/72000000-5.f295005d.png";